module.exports = __webpack_public_path__ + "efe533fd4a366e11581a7fc228f1dbf6.pdf";